import { Controller } from "@hotwired/stimulus"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { createRoot } from "react-dom/client"

import { CursorDataProvider } from "./contexts/CursorDataProvider"
import { CursorConverter } from "./CursorConverter"

import type { Root } from "react-dom/client"

export class CursorConverterController extends Controller<HTMLElement> {
  #root?: Root

  connect() {
    // Turbo snapshots the page before disconnect runs, so a restored copy still holds React's markup.
    this.element.replaceChildren()
    this.#root = createRoot(this.element)
    this.#root.render(
      <QueryClientProvider client={new QueryClient()}>
        <CursorDataProvider>
          <CursorConverter />
        </CursorDataProvider>
      </QueryClientProvider>,
    )
  }

  disconnect() {
    this.#root?.unmount()
    this.#root = undefined
  }
}
